window.locales = window.locales || {};window.locales.am = window.locales.am || {};window.locales.am.scheduleBox = window.locales.am.scheduleBox || {};window.locales.am.scheduleBox = {...window.locales.am.scheduleBox, ...{
    "fallbackHeading": "በዚህ ሳምንት",
    "requiredCourses": "አስፈላጊ ኮርሶች፡",
    "optionalCourses": "አማራጭ ኮርሶች፡",
    "viewFullSchedule": "ሙሉ መርሃ ግብር ይመልከቱ"
}
};window.locales.ar = window.locales.ar || {};window.locales.ar.scheduleBox = window.locales.ar.scheduleBox || {};window.locales.ar.scheduleBox = {...window.locales.ar.scheduleBox, ...{
    "fallbackHeading": "هذا الأسبوع",
    "requiredCourses": "الدورات المطلوبة:",
    "optionalCourses": "الدورات الاختيارية:",
    "viewFullSchedule": "عرض الجدول الكامل"
}
};window.locales.en = window.locales.en || {};window.locales.en.scheduleBox = window.locales.en.scheduleBox || {};window.locales.en.scheduleBox = {...window.locales.en.scheduleBox, ...{
    "fallbackHeading": "This Week",
    "requiredCourses": "Required Courses:",
    "optionalCourses": "Optional Courses:",
    "viewFullSchedule": "View Full Schedule"
}
};window.locales.es = window.locales.es || {};window.locales.es.scheduleBox = window.locales.es.scheduleBox || {};window.locales.es.scheduleBox = {...window.locales.es.scheduleBox, ...{
    "fallbackHeading": "Esta semana",
    "requiredCourses": "Cursos requeridos:",
    "optionalCourses": "Cursos opcionales:",
    "viewFullSchedule": "Ver horario completo"
}
};window.locales.it = window.locales.it || {};window.locales.it.scheduleBox = window.locales.it.scheduleBox || {};window.locales.it.scheduleBox = {...window.locales.it.scheduleBox, ...{
    "fallbackHeading": "Questa settimana",
    "requiredCourses": "Corsi obbligatori:",
    "optionalCourses": "Corsi opzionali:",
    "viewFullSchedule": "Visualizza programma completo"
}
};window.locales.zh = window.locales.zh || {};window.locales.zh.scheduleBox = window.locales.zh.scheduleBox || {};window.locales.zh.scheduleBox = {...window.locales.zh.scheduleBox, ...{
    "fallbackHeading": "本周",
    "requiredCourses": "必修课程：",
    "optionalCourses": "选修课程：",
    "viewFullSchedule": "查看完整日程"
}
};